import dayjs from "dayjs";

const normalizeDate = (val: any) =>
{
   if (dayjs.isDayjs(val)) return val;
   if (typeof val === "string") return dayjs(val);
   return val;
};

export const resolveTemplate = (template: any, data: any, fieldMeta?: any) =>
{
   const result: any = {};

   Object.keys(template).forEach((key) =>
   {
      const rawValue = template[key];

      const meta = fieldMeta?.[key];
      const widget = meta?.widget;

      const isDatePicker =
         widget === "date-picker" || widget === "date";

      const isFrom =
         key.includes("start") ||
         key.includes("from") ||
         key.includes("date_from");

      const isTo =
         key.includes("end") ||
         key.includes("to") ||
         key.includes("date_to");

      const formatDate = (val: any) =>
      {
         const d = normalizeDate(val);

         if (!dayjs.isDayjs(d)) return val;

         const isToday = d.isSame(dayjs(), "day");

         if (isFrom)
         {
            return (isToday ? dayjs() : d.startOf("day")).valueOf();
         }

         if (isTo)
         {
            return d.endOf("day").valueOf();
         }

         return d.valueOf();
      };

      const resolveValue = (val: any) =>
      {
         if (isDatePicker)
         {
            const normalized = normalizeDate(val);
            return formatDate(normalized);
         }
         return val;
      };

      if (typeof rawValue === "string")
      {
         // 🔥 match toàn bộ {key}
         const placeholderMatch = rawValue.match(/^{(.*?)}$/);

         if (placeholderMatch)
         {
            const varName = placeholderMatch[1];
            const value = data[varName];

            if (value !== undefined)
            {
               result[key] = resolveValue(value);
               return;
            }
         }

         // 🔥 replace {key} trong string
         result[key] = rawValue.replace(/{(.*?)}/g, (_, k) =>
         {
            const value = data[k];
            return resolveValue(value) ?? "";
         });

         return;
      }

      result[key] = resolveValue(rawValue);
   });

   return result;
};